import { configureStore, EnhancedStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import reducers from 'Reducer';
import { api } from 'Service';
import { apiViaCep } from 'View/Service/viacep';


// Cria uma store vazia somente para criar a tipagem do estado e do dispatch
const storeTemporaria = configureStore({
    reducer: reducers,
});

// Cria os tipos para o estado e o dispatch
export type Estado = ReturnType<typeof storeTemporaria.getState>;
export type Dispatch = typeof storeTemporaria.dispatch;

/**
 * Configura e retorna a store
 *
 * @param estado Estado inicial da store
 * @returns
 */
export default function configurarStore(estado: Estado|null = null): EnhancedStore  {
    return configureStore({
        reducer: reducers,
        ...estado ? { preloadedState: estado } : null,
        middleware: middlewares => middlewares()
            .concat(api.middleware, apiViaCep.middleware),
    });
}


// Cria as versões tipadas do useDispatch e useSelector
export const useAppDispatch = () => useDispatch<Dispatch>()
export const useAppSelector: TypedUseSelectorHook<Estado> = useSelector
